import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CategoriesLoader } from '../shared/Loaders';
import MediaQuery from 'react-responsive';
import CategoriesList from './CategoriesList';

import { rtlLangs } from '../../translations/rtl-langs';
import { isNewSeatmapDesign } from '../../utils/seatmapDesign';

export class Categories extends Component {
  render() {
    const {
      currentSeatmap,
      categories,
      showingDesktopCategories,
      theme,
      relativeWidthRatio,
      locale,
      useNewDesign,
    } = this.props;

    const CATEGORIES_DISPLAY_BARRIER = 1119;

    // In the new design categories render as a horizontal strip (CategoryStrip),
    // so this sidebar only renders in the legacy design.
    if (useNewDesign) return null;

    return this.props.loading ? (
      <CategoriesLoader />
    ) : (
      <MediaQuery maxWidth={CATEGORIES_DISPLAY_BARRIER / relativeWidthRatio}>
        {(matchMaxSmallWidth) => {
          const whetherToHide =
            matchMaxSmallWidth || !showingDesktopCategories ? 'gr-hidden' : '';
          const margin = rtlLangs.includes(locale)
            ? 'sm:gr-mr-10'
            : 'sm:gr-ml-10';
          return (
            <div
              className={`categories gr-sticky gr-z-100 gr-h-fit gr-shadow-inner ${whetherToHide} ${margin} gr-justify-center gr-items-center gr-h-auto gr-rounded-lg gr-bg-white gr-shadow-categories`}
              tabIndex={0}
              style={{
                width: '320px',
                top: '0px',
              }}
            >
              <div className="height-md:gr-p-6 gr-p-8 ">
                <CategoriesList
                  currentSeatmap={currentSeatmap}
                  categories={categories}
                  theme={theme}
                />
              </div>
            </div>
          );
        }}
      </MediaQuery>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  loading: state.session.loading,
  currentSeatmap: state.itinerary.currentSeatmap,
  theme: state.session.theme,
  showingDesktopCategories: state.session.showingDesktopCategories,
  relativeWidthRatio: state.session.relativeWidthRatio,
  locale: state.session.locale,
  seatmap: state.itinerary.seatmapsBySegment[state.itinerary.currentSeatmap],
  useNewDesign: isNewSeatmapDesign(state.session.variants),
});

export default connect(mapStateToProps)(Categories);
